import {FragmentId} from "../../records/entities/metadata/metadata.entity";

enum ExportJobIdBrand {
    _ = ''
}
export type ExportJobId = string & ExportJobIdBrand;

export enum ExportStatus {
    WAITING = 'Waiting',
    IN_PROGRESS = 'InProgress',
    COMPLETED = 'Completed',
    FAILED = 'Failed',
    CANCELLED = 'Cancelled',
    ALREADY_EXISTS = 'AlreadyExists'
}

export interface IExportJob {
    readonly ExportJobId: ExportJobId;
    readonly Name: string;
    readonly RecordId: FragmentId;
    readonly Status: ExportStatus;
    readonly Progress: number;
    readonly DownloadUrl: string;
    readonly CreationDate: string;
    readonly StartDate: string;
    readonly FinishDate: string;
    readonly ExpiryDate: string;
}
